import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import axiosInstance from "../../../utils/axios";
import { IErrorResponse } from "../../querys/querys.enum";
import { MutationKeys } from "../../mutation/mutation.enum";
import {
  SendNotificationRequest,
  SendNotificationResponse,
} from "../../../models/Interface/NotificationManagement.interface";

const sendNotification = async (data: SendNotificationRequest) => {
  const response = await axiosInstance.post<SendNotificationResponse>(
    `/notifications-management/send`,
    data
  );
  return response.data;
};

/**
 * POST /notifications-management/send — permission: `send:notification:management`
 *
 * Not idempotent: pushes are queued per recipient, so callers must block
 * double-submit while `isPending`.
 */
const useSendNotification = (
  options?: Partial<
    UseMutationOptions<
      SendNotificationResponse,
      AxiosError<IErrorResponse>,
      SendNotificationRequest
    >
  >
) => {
  return useMutation({
    mutationKey: [MutationKeys.SEND_NOTIFICATION_MANAGEMENT],
    mutationFn: sendNotification,
    ...options,
  });
};

export default useSendNotification;
